'use strict';

var numbers = require('../../utils/numbers.js');

var getColor = function (info) {
    if (!info.color) {
        return '';
    }
    return "<span style=\"color:" + info.color + "\">\u25CF</span>";
};
var xOnlyChart = function (info, tooltipFormatter) {
    if (tooltipFormatter) {
        return tooltipFormatter(info);
    }
    var percentage = !info.percentage ? '' : " (" + numbers.round(info.percentage, 0) + "%)";
    return getColor(info) + "<b>" + info.key + "</b><span>: " + info.y + percentage + "</span>";
};
var Tooltip = {
    xOnlyChart: xOnlyChart,
    getColor: getColor,
};

module.exports = Tooltip;
